
















































import Vue from "vue";
import VueMultiselect from "vue-multiselect";
import { Element } from "@/types";
import { erklServiceInstance } from "@/services/ErklService";

export default Vue.extend({
  name: "MultiselectWithFilter",
  components: {
    VueMultiselect,
  },
  props: {
    value: {
      type: Array as () => Array<any>,
      default: () => [],
    },
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: undefined,
    },
    akgId: {
      type: [String, Number],
      required: true,
    },

    trackBy: {
      type: String,
      default: "bez",
    },
    addable: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      selected: this.value,
      kommunen: [] as Element[],
      incOrte: false,
      incOrtsteile: false,
      isLoading: false,
    };
  },
  watch: {
    incOrte() {
      this.openSelect();
      this.asyncFind();
    },
    incOrtsteile() {
      this.openSelect();
      this.asyncFind();
    },
    value() {
      if (this.value !== this.selected) {
        this.selected = this.value;
        this.onChange();
      }
    },
    selected() {
      this.$emit("input", this.selected);
    },
  },
  computed: {
    title(): String {
      return (
        this.value?.map((el) => el[this.trackBy] as string).join(", ") || ""
      );
    },
  },
  mounted() {
    this.onChange();
    this.asyncFind();
  },
  methods: {
    openSelect() {
      ((this.$refs.vms as Vue).$el as HTMLElement).focus();
    },
    addNew(element: String) {
      const obj = { id: "", bez: element };
      this.selected.push(obj);
      //this.kommunen.push(obj);
    },
    sortSelected() {
      this.selected = this.selected.sort(function (a, b) {
        return a.bez.localeCompare(b.bez);
      });
    },
    onChange() {
      this.sortSelected();
      //window.setTimeout(this.sortSelected, 100);
    },
    asyncFind() {
      this.isLoading = true;
      erklServiceInstance
        .getKommunenWithFilter(this.akgId, this.incOrte, this.incOrtsteile)
        .then((data: Element[]) => {
          this.kommunen = data;
          this.isLoading = false;
        });
    },
  },
});
